import clsx from 'clsx';
import Link from 'next/link';
import React from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const ArticleBreadcrumbs = _ref => {
  let {
    items,
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles.container, className),
    children: items.map((item, i) => /*#__PURE__*/_jsx("li", {
      className: styles.item,
      children: item.href ? /*#__PURE__*/_jsx(Link, {
        className: styles.link,
        href: `${item.href}`.toLowerCase(),
        children: item.text
      }) : /*#__PURE__*/_jsx("span", {
        children: item.text
      })
    }, i))
  });
};

export default ArticleBreadcrumbs;